const o = {
  name: "ZoomIn",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16V12H16V10H12V6H10V10H6V12H10V16H12Z" fill="currentColor"/>
<path d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6176 18.032L20.9999 22.4142L22.4141 21L18.0318 16.6178C19.2635 15.0781 20 13.125 20 11C20 6.02944 15.9706 2 11 2ZM4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ZoomIn
};
